export default __webpack_public_path__ + "images/W7.ddc9dfb.png";